export class RRWebviewerFileThreeD {
  obj: string;
  texture?: string;
}
